module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_PopOutWindow_16"],"path":[{"$":{"d":"M6.29,8.29l2.5-2.5L7,4h5V9L10.21,7.21l-2.5,2.5ZM11,15H1V5H2V4H0V16H12V14H11ZM16,0V13H3V0ZM14,2H5v9h9Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_PopOutWindow_16.svg
// module id = a30o
// module chunks = 1